module.exports = __webpack_public_path__ + "static/img/diy-power.73115b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-power.png
// module id = 35EX
// module chunks = 0